import { GLOBAL_COLORS_NIDHOGG_L2 } from '../config/globalSettings';

// --- DEFINE LIGHT GROUPS ---
const STD_LIGHTS = ["x300u_a", "x300u_b", "x300v_a", "x300v_b", "tlr7"];
const GLOCK_RH_LIGHTS = [...STD_LIGHTS, "xvl2", "x400v_a_irc", "x400u_a_rd"];
const SIG_P320_LIGHTS = [...STD_LIGHTS, "sig_foxtrot2r"];

export const nidhoggLvl2Data = {
  // --- GUN MODELS ---
  guns: [
    { id: "beretta_m9a1", name: "Beretta M9A1", supported_lights: STD_LIGHTS },
    { id: "beretta_m9a3", name: "Beretta M9A3", supported_lights: STD_LIGHTS },
    { id: "beretta_m9a4", name: "Beretta M9A4", supported_lights: STD_LIGHTS },
    { id: "beretta_92g", name: "Beretta 92G", supported_lights: STD_LIGHTS },
    { id: "beretta_92x", name: "Beretta 92X(Not Performance)", supported_lights: STD_LIGHTS },
    { id: "glock_19", name: "Glock 19", supported_lights: GLOCK_RH_LIGHTS, supported_lights_lh: STD_LIGHTS },
    { id: "glock_17", name: "Glock 17", supported_lights: GLOCK_RH_LIGHTS, supported_lights_lh: STD_LIGHTS },
    { id: "glock_34", name: "Glock 34", supported_lights: GLOCK_RH_LIGHTS, supported_lights_lh: STD_LIGHTS },
    // The M17 and M18 are P320 frames - they take these holsters, so they are
    // listed here by name rather than as separate models. Every P320 in this
    // builder carries the Foxtrot2R on top of the standard lights.
    { id: "sig_p320_compact", name: "SIG Sauer P320 Compact (FITS: M18)", supported_lights: SIG_P320_LIGHTS },
    { id: "sig_p320_full", name: "SIG Sauer P320 Full Size (FITS: M17)", supported_lights: SIG_P320_LIGHTS },
    { id: "sig_p320_x5", name: "SIG Sauer P320 X5", supported_lights: SIG_P320_LIGHTS },
    { id: "sw_mp_20_4", name: "S&W M&P®9 M2.0 4\"", supported_lights: STD_LIGHTS },
    { id: "sw_mp_20_425", name: "S&W M&P®9 M2.0 4.25\"", supported_lights: STD_LIGHTS },
    { id: "sw_mp_20_5", name: "S&W M&P®9 M2.0 5\"", supported_lights: STD_LIGHTS },
    { id: "sw_mp_20_metal", name: "S&W M&P®9 M2.0 METAL", supported_lights: STD_LIGHTS },
    { id: "walther_pdp_4", name: "Walther PDP Compact Full Size 4\"", supported_lights: STD_LIGHTS },
    { id: "walther_pdp_45", name: "Walther PDP Full Size 4.5\"", supported_lights: STD_LIGHTS },
    { id: "walther_pdp_5", name: "Walther PDP Full Size 5\"", supported_lights: STD_LIGHTS },
  ],

  // --- LIGHT OPTIONS ---
  lights: [
    { id: "x300u_a", name: "Surefire X300U-A (Quick Release Lever ONLY)" },
    { id: "x300u_b", name: "Surefire X300U-B" },
    { id: "x300v_a", name: "Surefire X300 Vampire-A (Quick Release Lever ONLY)" },
    { id: "x300v_b", name: "Surefire X300 Vampire-B" },
    { id: "x400v_a_irc", name: "SureFire X400V-A-IRC" },
    { id: "x400u_a_rd", name: "SureFire X400U-A-RD" },
    { id: "tlr7", name: "TLR-7A/X/HLX" },
    { id: "xvl2", name: "Surefire XVL2" },
    { id: "sig_foxtrot2r", name: "SIG Foxtrot2R" }
  ],

  // --- DRAW HAND ---
  hands: [
    { id: "right", name: "Right Hand" },
    { id: "left", name: "Left Hand" } 
  ],

  // --- COLORS ---
  colors: GLOBAL_COLORS_NIDHOGG_L2,

  // --- MOUNTING OPTIONS ---
  mounts: [
    { 
      id: "qls_fork", 
      name: "Safariland QLS Fork (Black)", 
      price: 18.00,
      img_layer_mount: "/images/mounts/nidhogg_l2/qls_fork_front.png", 
      img_layer_mount_back: "/images/mounts/nidhogg_l2/qls_fork_back.png",
      description: "Standard fork only. No receiver plate included."
    },
    { 
      id: "rti_hanger", 
      name: "G-Code RTI Hanger", 
      price: 14.00,
      img_layer_mount: "/images/mounts/nidhogg_l2/rti_hanger_front.png",
      img_layer_mount_back: "/images/mounts/nidhogg_l2/rti_hanger_back.png",
      description: "Compatible with G-Code RTI wheels and mounts."
    },
    {
      id: "tek_lok",
      name: "Blade-Tech Tek-Lok",
      price: 12.99,
      img_layer_mount: "/images/mounts/nidhogg_l2/tek_lok_front.png",
      img_layer_mount_back: "/images/mounts/nidhogg_l2/tek_lok_back.png",
      description: "Industry standard Blade-Tech Tek-Lok hinged belt clip. Fits belts up to 2.25\"."
    },
    { 
      id: "tac_belt_bolted", 
      name: "Tactical Belt Mount (Bolted Directly)", 
      price: 0, 
      img_layer_mount: "/images/mounts/nidhogg_l2/tac_belt_bolted_front.png", 
      img_layer_mount_back: "/images/mounts/nidhogg_l2/tac_belt_bolted_back.png",
      description: "Bolted directly to the holster. Choose color and size below."
    },
    { 
      id: "dropleg_qls", 
      name: "Full Dropleg Setup with QLS", 
      price: 39.99, 
      img_layer_mount: "/images/mounts/nidhogg_l2/qls_fork_front.png", 
      img_layer_mount_back: "/images/mounts/nidhogg_l2/qls_fork_back.png",
      description: "Complete setup including shroud, strap, and QLS system. View system via the toggle button."
    },
    { 
      id: "dropleg_no_qls", 
      name: "Full Dropleg Setup (No QLS)", 
      price: 0, 
      img_layer_mount: "", 
      img_layer_mount_back: "",
      description: "Complete setup bolted directly to shroud (No Quick Locking System). View system via the toggle button."
    }
  ],

  // --- SUB-OPTIONS FOR TAC BELT ---
  tac_belt_colors: [
    { id: "black", name: "Black", price: 17.99 },
    { id: "coyote", name: "Coyote", price: 17.99 },
    { id: "od_green", name: "OD Green", price: 17.99 },
    { id: "light_grey", name: "Light Grey", price: 17.99 },
    { id: "foliage_green", name: "Foliage Green", price: 17.99 },
    { id: "multicam", name: "Multicam", price: 34.99 },
    { id: "multicam_black", name: "Multicam Black", price: 34.99 },
    { id: "multicam_tropic", name: "Multicam Tropic", price: 34.99 },
    { id: "multicam_arid", name: "Multicam Arid", price: 34.99 }
  ],
  tac_belt_sizes: [
    { id: "std_150", name: "Standard 1.50\"", price: 0 },
    { id: "std_175", name: "Standard 1.75\"", price: 0 },
    { id: "std_200", name: "Standard 2.0\"", price: 0 },
    { id: "short_150", name: "Short 1.50\"", price: 0 },
    { id: "short_175", name: "Short 1.75\"", price: 0 },
    { id: "short_200", name: "Short 2.0\"", price: 0 }
  ],

  // --- SUB-OPTIONS FOR DROPLEG ---
  fulcrum_colors: [
    { id: "black", name: "Black", price: 15.99 },
    { id: "carbon_fiber", name: "Carbon Fiber", price: 15.99 },
    { id: "coyote_carbon", name: "Coyote Tan Carbon Fiber", price: 15.99 }
  ],
  thigh_band_colors: [
    { id: "black", name: "Black", price: 16.99 },
    { id: "tan", name: "Tan", price: 16.99 }
  ],

  // --- MAG CARRIER ADDONS (NEW) ---
  mag_carriers: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "yes_1", name: "Yes Add 1", price: 29.99 },
    { id: "yes_2", name: "Yes Add 2", price: 49.99 },
    { id: "mystery", name: "1 Mystery Limited Edition Kydex Pattern", price: 29.99 }
  ],

  // --- ADD-ON MAG MOUNTS (LOWER PRICING) ---
  mag_mounts: [
    { id: "clip_15", name: "1.5\" Injection Molded Clip", price: 0 },
    { id: "clip_175", name: "1.75\" Injection Molded Clip", price: 0 },
    { id: "dcc_ANRlogo", name: "1.5\" DCC Monoblock ANR Logo", price: 4.99 },
    { id: "dcc_nologo", name: "1.5\" DCC Monoblock No Logo", price: 4.49 },
    { id: "dcc_FDElogo", name: "1.5\" DCC Monoblock FDE w/ Logo", price: 4.99 },
    { id: "dcc_TOPOlogo", name: "1.5\" DCC Monoblock Topographical", price: 5.49 },
    { id: "neomag", name: "Neomag Alias TPost", price: 15.99 },
    { id: "neomag_receiver", name: "Neomag Alias TPost and Neomag Alias Belt Receiver", price: 49.99 }
  ],

  // --- EXTRAS ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};